import React from 'react'
import ComparisonItem from '../ComparisonItem/ComparisonItem'
import styles from './comparisonList.module.scss'

const ComparisonList = ({persons, isActive, onClick}) => {
   return (
      <ul className={styles.modal__list}>
         {persons.map(({id, ...props}) => (
            <ComparisonItem key={id} id={id} {...props} onClick={onClick} isActive={isActive}>
               {isActive.some(el => el === id.toString()) ?
                  <svg className={styles.modal__choice} width='28' height='28' viewBox='0 0 28 28' fill='none'
                       xmlns='http://www.w3.org/2000/svg'>
                     <circle cx='14' cy='14' r='12' fill='#95D4EC' stroke='#F9FDFF' strokeWidth='4' />
                     <path
                        d='M8.48367 15.768C7.99893 15.271 7.99893 14.4647 8.48367 13.9678C8.96805 13.4704 9.75392 13.4704 10.2387 13.9678L12.3307 16.1143L17.6797 9.18794C18.1028 8.63857 18.8798 8.54518 19.4152 8.97882C19.9507 9.4129 20.0417 10.2101 19.6187 10.7595L13.4754 18.7148C13.4291 18.7879 13.3748 18.8572 13.312 18.9213C12.8276 19.4186 12.0417 19.4186 11.5574 18.9213L8.4841 15.768L8.48367 15.768Z'
                        fill='white' />
                  </svg>
                  : ''}
            </ComparisonItem>
         ))}
      </ul>
   )
}

export default ComparisonList